import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EOtpremniceClient, FileParameter, SefClient, TipIzmenePosiljke } from '@kodit/core/data-api';
import { FormHelper } from '@kodit/core/form-definitions';
import { AlertService, ButtonService, MixpanelService, SharedService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef, FileUploadService } from '@kodit/core/shared-ui';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-start-voznje-form',
  templateUrl: './start-voznje-form.component.html',
  styleUrls: ['./start-voznje-form.component.scss']
})
export class StartVoznjeFormComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();
  form: FormGroup;
  readonly MAX_FILE_SIZE: number = 75000000;

  constructor(
    private _fb: FormBuilder,
    private _client: EOtpremniceClient,
    private _alertService: AlertService,
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig,
    private _formHelper: FormHelper,
    private _uploadService: FileUploadService,
    private _buttonService: ButtonService,
    private _mixpanelService : MixpanelService,
    private _sharedService : SharedService
  ) { }

  ngOnInit(): void {

    this._uploadService.setMaxAttachmentSize = this.MAX_FILE_SIZE;

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._startVoznje();
      })
    );

    this.form = this._fb.group({
      otpremnicaId: new FormControl(this._dialogConfig.data.otpremnicaId, {
        validators: Validators.required,
      }),
      attachments: new FormArray([]),

    });

    this._subs.add(
      this._uploadService.getAttachments.subscribe((attachments: File[]) => {
        (this.form.controls.attachments as FormArray).clear();
        attachments.forEach((x) => {
          (this.form.controls.attachments as FormArray).push(
            new FormControl(x)
          );
        });
      })
    );

  }

  private _startVoznje() {

    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    this._buttonService.disableButton();

    const attachments: FileParameter[] = this.form.value.attachments
      ? this.form.value.attachments.map((x: File) => ({
          data: x,
          fileName: x.name,
        }))
      : null;

    // everything is ok, let's send it
    this._sharedService.displayLoadingScreen(true, "Startovanje vožnje...");
    this._subs.add(
      this._client
        .akcijaOtpremnice(
          this._dialogConfig.data.otpremnicaId,
          TipIzmenePosiljke.START_PREVOZA,
          attachments[0]
        )
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          if(res.succeeded){
            this._alertService.addSuccessMsg("Uspešan početak prevoza");
            this._dialogRef.close(true);
            return;
          }
          this._alertService.addFailedMsg(res.messages[0]);
          this._dialogRef.close(true);
        })
    );
  }

  handleUpload(files: File[]) {
    files.forEach((file) => {
      (this.form.controls.attachments as FormArray).push(new FormControl(file));
    });
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
